import { render } from "./mvt-saleproceedsnew.vue?vue&type=template&id=c0547250"
import script from "./mvt-saleproceedsnew.js?vue&type=script&lang=js"
export * from "./mvt-saleproceedsnew.js?vue&type=script&lang=js"

import "./mvt-saleproceedsnew.vue?vue&type=style&index=0&id=c0547250&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__